




















































































































































import api from "@/api/index"; //ABP API接口
import { Vue, Component, Ref } from "vue-property-decorator";

import {
  CloseReportDto,
  SummaryReportDto,
  AuditFlowScope,
} from "@/api/appService";
import PagedTableView from "@/components/PagedTableView/index.vue";
import OrganizationSelect from "@/components/OrganizationSelect/index.vue";
import AgileAuditTag from "@/components/AgileAuditTag/index.vue";
import SendNotify from "@/components/SendNotify/index.vue";

@Component({
  name: "RoleList",
  components: {
    SendNotify,
    PagedTableView,
    OrganizationSelect,
    AgileAuditTag,
  },
})
export default class ExternalProjectCloseReportList extends Vue {
  @Ref() showNotify!: SendNotify;
  queryForm: any = {
    projectName: "",
    orgName: "",
    startDate: "",
    endDate: "",
  };

  get getNotifyApiUrl() {
    return api.externalProjectCloseReport.sendNotify;
  }

  created() {
    if (this.$route.query.projectId) {
      this.queryForm.projectId = Number(this.$route.query.projectId);
    }
  }

  // 获取表数据
  fetchData(params: any) {
    return api.externalProjectCloseReport.getAll(params);
  }

  // 新建
  handleCreate() {
    this.$router.push({ name: "externalProjectCloseReportCreate" });
  }

  // 发送通知
  handleShowNotify() {
    (this.showNotify as any).isShowNotify = true;
  }

  handleMenu(e: any) {
    switch (e.type) {
      case "detail": {
        this.jumpDetail(e.index, e.item);
        return;
      }
      case "edit": {
        this.handleEdit(e.index, e.item);
        return;
      }
      case "delete": {
        this.handleDelete(e.index, e.item);
        return;
      }
      case "startAudit": {
        this.handleStartAudit(e.index, e.item);
        return;
      }
      case "auditFlow": {
        this.handleAuditFlow(e.index, e.item);
        break;
      }
    }
  }

  // 查看详情
  jumpDetail(index: number, row: CloseReportDto) {
    this.$router.push({
      name: "externalProjectCloseReportDetail",
      params: { id: row.id!.toString() },
    });
  }

  // 编辑
  handleEdit(index: number, row: CloseReportDto) {
    this.$router.push({
      name: "externalProjectCloseReportEdit",
      params: { id: row.id!.toString() },
    });
  }

  // 删除
  async handleDelete(index: number, row: any) {
    this.$confirm("你确定删除吗?", "提示").then(async () => {
      await api.externalProjectCloseReport
        .delete({ id: row.id })
        .then((res) => {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        });
    });
  }

  // 提交审核
  async handleStartAudit(item: number, node: SummaryReportDto) {
    // await api.externalProjectCloseReport.startAudit({
    //   body: {
    //     id: node.id
    //   }
    // });
  }

  handleAuditFlow(index: number, row: any) {
    this.$router.push({
      name: "auditFlowDetail",
      params: {
        hostType: AuditFlowScope.ExternalProjectCloseReport,
        hostId: row.id,
        auditFlowId: row.auditFlowId,
      },
    });
  }
}
